import * as React from 'react';
import { getSignifydSessionId, saveSignifydSessionId } from '@/redux/modules/signifyd';
import { getUseSignifyd } from '@/redux/modules/config';
import { GlobalState } from '@/redux/rootReducer';
import { Helmet } from 'react-helmet-async';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { v4 as uuidv4 } from 'uuid';

const Signifyd = () => {
    const dispatch = useAppDispatch();

    const signifydSessionId = useAppSelector((state: GlobalState) => getSignifydSessionId(state));
    const useSignifyd = useAppSelector((state: GlobalState) => getUseSignifyd(state));

    React.useEffect(() => {
        if (useSignifyd) {
            const newSessionId = uuidv4();
            dispatch(saveSignifydSessionId(newSessionId));
        }
    }, [dispatch, useSignifyd]);

    return signifydSessionId ? (
        <Helmet>
            <script
                data-order-session-id={signifydSessionId}
                defer
                id="sig-api"
                src="https://cdn-scripts.signifyd.com/api/script-tag.js"
                type="text/javascript"
            />
        </Helmet>
    ) : null;
};

export default Signifyd;
